export default {
  addSuccessNotification(state, success_notification) {
    state.success_notifications.push({ id: success_notification.id, timer: success_notification.timer, title: success_notification.title, message: success_notification.message });
  },
  reduceTimer(state, {success_notification_id, time_reduce}) {
    for (let i = 0; i < state.success_notifications.length; i++) {
      state.success_notifications[i].id;
      if (state.success_notifications[i].id == success_notification_id) {
        state.success_notifications[i].timer -= time_reduce;
        break;
      }
    }
  },
  removeSuccessNotification(state, success_notification_id) {
    for (let i = 0; i < state.success_notifications.length; i++) {      
      if (state.success_notifications[i].id == success_notification_id) {
        state.success_notifications.splice(i, 1);
        break;
      }
    }
  }
};
